import { useEffect, useState } from "react";
import styled from "styled-components";
import log from "loglevel";
import { AiOutlineRead } from 'react-icons/ai';
import { AiOutlineLike } from 'react-icons/ai';
import { AiFillLike } from "react-icons/ai";
import { AiOutlineDislike } from "react-icons/ai";
import { AiFillDislike } from "react-icons/ai";
import { AiOutlineHeart } from "react-icons/ai";
import { AiFillHeart } from "react-icons/ai";

const ReactionsContainer = styled.div`
  //background: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${({ $compact }) => $compact ? '110px' : '220px'};
`;

const ViewsSection = styled.div`
  /* background: green;   */
  color: black;
  display: flex;
  align-items: center;
`;

const ViewsIcon = styled.div`
  margin-top: 3px;
  margin-right: 5px;
  width: 30px;
`;

const ReactionsSectionCommon = styled.div`
  // background: gray;  
  display: flex;
  align-items: center;
`;

const LikesSection = styled(ReactionsSectionCommon)`
`;

const DislikesSection = styled(ReactionsSectionCommon)`
`;

const HeartsSection = styled(ReactionsSectionCommon)`
`;

const ReactionsIconCommon = styled.div`
  width: ${({ $compact }) => $compact ? '16px' : '25px'};
  margin-right: 5px;
  cursor: pointer;

  &:hover {
    color: hotpink;
  }
`;

const LikesIcon = styled(ReactionsIconCommon)`
`;

const DislikesIcon = styled(ReactionsIconCommon)`
`;

const HeartsIcon = styled(ReactionsIconCommon)`
`;

export const Reactions = ({
  user,
  target,
  views,
  compact = false,
  submitVote,
  deleteVote,
  createHeart,
  deleteHeart,
}) => {
  const [votes, setVotes] = useState({
    likes: undefined,
    dislikes: undefined,
    vote: 0,
  });

  const [hearts, setHearts] = useState({
    count: undefined,
    is_hearted: false,
  });

  const [pending, setPending] = useState(false);

  useEffect(() => {
    setVotes({
      likes: target.likes,
      dislikes: target.dislikes,
      vote: target.vote
    });
    
    setHearts({
      count: target.hearts,
      is_hearted: target.is_hearted
    });
  }, [target.vote, target.likes, target.dislikes, target.hearts, target.is_hearted]);

  const handleVote = async (vote) => {
    if (user.id === target.author) return;
    if (pending) return;
    setPending(true);

    const prevState = {...votes};
    const nextVote = votes.vote === vote ? 0 : vote;

    let likes = votes.likes;
    let dislikes = votes.dislikes;

    if (votes.vote === 1) likes -= 1;
    if (nextVote === 1) likes += 1;
    if (votes.vote === -1) dislikes -= 1;
    if (nextVote === -1) dislikes += 1;

    setVotes(prev => ({...prev, likes, dislikes, vote: nextVote}));

    try {
      if (nextVote === 0) {
        const response = await deleteVote(target.id);
        log.debug('VOTE_DELETE_SUCCESS', response);
      } else {
        const data = {"value": nextVote};
        const response = await submitVote(target.id, data);
        log.debug('VOTE_SUBMIT_SUCCESS', response);
      }
    } catch (e) {
      log.debug('VOTE_FAILED', e);
      setVotes(prevState);
    } finally {
      setPending(false);
    }
  };

  const handleHeart = async () => {
    if (user.id === target.author) return;
    if (pending) return;

    setPending(true);
  
    const prevState = { ...hearts };

    if (hearts.is_hearted) {
      setHearts(prev => ({...prev, count: prev.count - 1, is_hearted: false}));
    } else {
      setHearts(prev => ({...prev, count: prev.count + 1, is_hearted: true}));
    }

    try {
      if (hearts.is_hearted) {
        const response = await deleteHeart(target.id);
        log.debug('HEART_DELETE_SUCCESS', response);
      } else {
        const response = await createHeart(target.id);
        log.debug('HEART_CREATE_SUCCESS', response);
      }
    } catch (e) {
      log.debug('HEART_FAILED', e);
      setHearts(prevState);
    } finally {
      setPending(false);
    }
  };
  
  return (
    <div className="Reactions">
      <ReactionsContainer $compact={compact}>

        {views != null &&
          <ViewsSection>
            <ViewsIcon><AiOutlineRead size="100%" /></ViewsIcon>
            <span>{views}</span>
          </ViewsSection>
        }
        
        <LikesSection>
          <LikesIcon $compact={compact} onClick={() => handleVote(+1)}>
            {votes.vote === 1 ? <AiFillLike size="100%" color="hotpink" /> : <AiOutlineLike size="100%" />}
          </LikesIcon>
          {votes.likes != null && <span>{votes.likes}</span>}
        </LikesSection>

        <DislikesSection>
          <DislikesIcon $compact={compact} onClick={() => handleVote(-1)}>
            {votes.vote === -1 ? <AiFillDislike size="100%" color="hotpink" /> : <AiOutlineDislike size="100%" />}
          </DislikesIcon>
          {votes.dislikes != null && <span>{votes.dislikes}</span>}
        </DislikesSection>
        
        <HeartsSection>
          <HeartsIcon $compact={compact} onClick={handleHeart}>
            {hearts.is_hearted ? <AiFillHeart size="100%" color="red" /> : <AiOutlineHeart size="100%" />}
          </HeartsIcon>
          {hearts.count != null && <span>{hearts.count}</span>}
        </HeartsSection>

      </ReactionsContainer>
    </div>
  );
};